/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 11:50:22                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-06 12:19:31                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * CompInfoSelectCheckbox: display compinfo checkbox type
    * isChecked: check if choice is checked
    * handleChange: handle switch state change
*/

/* Imports */
import Checkbox from "../../checkbox/Checkbox";
/***/

/**
* CompInfoSelectCheckbox: display compinfo checkbox type
* @param choices - list of avaible choices
* @param values - previous selected values
* @param onChange - on change event
* @param className - additional className
*/
export default function CompInfoSelectCheckbox({
  choices,
  values,
  onChange,
  className = ""
}: {
  choices: EasyTech.CompInfoChoice[],
  values: EasyTech.CompInfoChoice[],
  onChange: (data: EasyTech.CompInfoChoice[]) => void,
  className?: string
}) {
  /**
   * Récupère le label traduit d'un choix de compInfo selon la langue de l'utilisateur
   * @param choice - Choix contenant les traductions
   * @returns Label traduit ou label par défaut
   */
  const getTranslatedChoiceLabel = (choice: EasyTech.CompInfoChoice): string => {
    const currentLanguage = localStorage.getItem("i18nextLng") || "en";
    
    if (choice.translations && Array.isArray(choice.translations)) {
      const translation = choice.translations.find(
        (translation) => translation.language?.isoCode === currentLanguage
      );
      
      if (translation && translation.label) {
        return translation.label;
      }
    }
    
    // Fallback sur le label par défaut
    return choice.label || "";
  };

  /**
  * isChecked: check if choice is checked
  * @param choice - current choice
  * @retrun - checked or not
  */
  const isChecked = (choice: EasyTech.CompInfoChoice): boolean => {
    return values.find((el) => el.id === choice.id) ? true : false;
  };
  /***/
  
  /**
  * handleChange: handle switch state change
  * @param choice - current choice changed
  */
  const handleChange = (choice: EasyTech.CompInfoChoice) => {
    const ret = [...values];
    const i = ret.findIndex((el) => el.id === choice.id);

    if (i !== -1) ret.splice(i, 1);
    else ret.push(choice);

    onChange(ret);
  };
  /***/

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {choices.map((el) => (
        <div key={el.id} className="flex items-center justify-between gap-3">
          <span className="text-sm text-gray-500">{getTranslatedChoiceLabel(el)}</span>
          <Checkbox
            checked={isChecked(el)}
            onChange={() => handleChange(el)}
          />
        </div>
      ))}
    </div>
  );
}
/***/
